(function($) {
 
    

   

    if (window.matchMedia("(max-width: 1099px)").matches) {
      $('.benefits-section').insertAfter('#site-control .cc-announcement');
      $('.benefits-section .flexible-layout').flickity({
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        prevNextButtons: false,
         autoPlay:3000,
        pageDots: false
      })
    } else {
      $('.benefits-section').appendTo('#site-control');
      
    }



  $(document).ready(function() {
       $('.swiper-testimonials').flickity({
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false
        })

    

      // $('.thumbs_container .product-area__thumbs__thumb').on( 'click', function() {
      //     var index = $(this).index();
      //     $('.theme-gallery.product-slider .theme-images').flickity( 'select', index );
      //   });


      $('.cb-product-images').flickity({
              cellAlign: 'left',
              contain: true,
              wrapAround: false,
              prevNextButtons: true,
              pageDots: false,
              asNavFor:  '.thumbs_container'
        })
      
        $('.thumbs_container').flickity({
                cellAlign: 'left',
                contain: true,
                wrapAround: false,
                prevNextButtons: false,
                pageDots: false,
                asNavFor:  '.cb-product-images'
          })
    $('.cb-product-images').find('.gallery-product-image').each(function(){
      var largeImg = $(this).data('full-size');
      $(this).find('.rimage-wrapper').zoom({url: largeImg, magnify: 2, touch:false });
    })
      // $('a.photo').zoom({url: 'photo-big.jpg'});
    
      if (window.matchMedia("(max-width: 767px)").matches) {
        // $('.thumbs_container').flickity({
        //         cellAlign: 'left',
        //         contain: true,
        //         wrapAround: false,
        //         prevNextButtons: false,
        //         pageDots: false
        //   })

        // $('.thumbs_container .product-area__thumbs__thumb').on( 'click', function() {
        //   var index = $(this).index();
        //   $('.cb-product-slider .theme-img').each(function(i,k){
        //     // var t_index = i + 1; 
        //     // console.log(index,i)
        //     if (index == i) {
        //        console.log(index,i)
        //       $(this).click();
        //     }
        //   })
        //   // $('.theme-gallery.product-slider .theme-images').flickity( 'select', index );
        // });
        
      } else {

       // $('.cb-product-images').flickity({
       //        cellAlign: 'left',
       //        contain: true,
       //        wrapAround: false,
       //        prevNextButtons: true,
       //        pageDots: false,
       //        asNavFor:  '.thumbs_container'
       //  })
      
       //  $('.thumbs_container').flickity({
       //          cellAlign: 'left',
       //          contain: true,
       //          wrapAround: false,
       //          prevNextButtons: false,
       //          pageDots: false,
       //          asNavFor:  '.cb-product-images'
       //    })
      }
     

      
    }); //end ready

  
})(jQuery);